/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MessagingProvider } from '@src/model/frontendmodel';
// eslint-disable-next-line import/no-cycle
import { BotAccount, ErrorPayload } from '@types';

export type AllBotAccountsState = {
  botAccounts: BotAccount[];
  botAccountsRequestStatus: 'idle' | 'pending' | 'success' | 'failure';
  botAccountsRequestError?: ErrorPayload;
};

const initialState: AllBotAccountsState = {
  botAccountsRequestStatus: 'idle',
  botAccountsRequestError: undefined,
  botAccounts: [],
};

const allBotAccountsSlice = createSlice({
  name: 'allBotAccountsSlice',
  initialState,
  reducers: {
    fetchAllBotAccounts(
      state,
      _: PayloadAction<MessagingProvider | undefined>
    ) {
      state.botAccountsRequestStatus = 'pending';
      state.botAccountsRequestError = undefined;
    },
    fetchAllBotAccountsSuccess(state, action: PayloadAction<BotAccount[]>) {
      state.botAccountsRequestStatus = 'success';
      state.botAccountsRequestError = undefined;
      state.botAccounts = action.payload;
    },
    fetchAllBotAccountsFailure(state, action: PayloadAction<ErrorPayload>) {
      state.botAccountsRequestStatus = 'failure';
      state.botAccountsRequestError = action.payload;
    },

    fetchAllBotAccountsFulfill(state) {
      state.botAccountsRequestStatus = 'idle';
      state.botAccountsRequestError = undefined;
    },
  },
});

export default allBotAccountsSlice.reducer;

export const allBotAccounts = allBotAccountsSlice.actions;
